// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"825":"2639c35b","901":"f8797133"}[chunkId] + ".chunk.js";
};